module.exports = __webpack_public_path__ + "media/images/markitup/bold-408129053b782c76cc20a3a28b90e4cf.png";